export * from './lib/zendesk-messenger'
export {
  zendeskMessengerScriptProps,
  getZendeskScriptUrl,
} from '@cinch-nx/zendesk-utils'
